'use client';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { colors } from '@startengine/design-system.theme.main';
import PropTypes from 'prop-types';
import React from 'react';

export const StyledGreenATag = styled(Typography)(({ color }) => ({
  color,
  cursor: 'pointer',
}));

export const GreenATag = ({ children = <div />, variant = '', color = colors.SETeal, ...rest }) => (
  <StyledGreenATag component="span" variant={variant} color={color} {...rest}>
    {children}
  </StyledGreenATag>
);

GreenATag.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
};

export const GreenLink = ({
  link = '',
  text = '',
  variant = '',
  color = colors.SEDark,
  textDecoration = 'none',
}) => (
  <a
    href={link}
    target="_blank"
    style={{
      textDecoration,
      fontWeight: 700,
    }}
    rel="noopener noreferrer"
  >
    <GreenATag variant={variant} color={color}>
      {text}
    </GreenATag>
  </a>
);

GreenLink.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  textDecoration: PropTypes.string,
};
